import { render } from "./family-list.vue?vue&type=template&id=7dc184eb&scoped=true"
import script from "./family-list.vue?vue&type=script&lang=js"
export * from "./family-list.vue?vue&type=script&lang=js"

import "./family-list.vue?vue&type=style&index=0&id=7dc184eb&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc184eb"]])

export default __exports__